import HeaderWithoutMenu from '../components/common/landingPage/HeaderWithoutMenu';
import Footer from '../components/common/landingPage/Footer';

const TermsOfServicesData = [
  {
    question: '¿QUÉ ES FLOWEX PAY Y QUÉ OFRECEMOS?', // 1
    answers: [
      {
        type: 'circle',
        text: 'Flowex Pay es una plataforma tecnológica (marca de Loaded Colombia SAS, NIT 901910428-1) que facilita:',
        subText: [
          'Transferencias internacionales de dinero hacia países como Estados Unidos (ACH), Europa (SEPA), México (SPEI), Brasil (PIX), Argentina, China y otros corredores habilitados por nuestros aliados.',
          'Una cuenta virtual en Estados Unidos con número de cuenta y routing number, que te permite enviar y recibir pagos en dólares como si tuvieras una cuenta bancaria en ese país.',
          'Acceso, en calidad de intermediario tecnológico, a protocolos de finanzas descentralizadas (DeFi) —en particular al protocolo Kamino Main Market sobre la red Solana— mediante los cuales los usuarios pueden destinar sus activos digitales (USDC) para generar recompensas variables, sujetas a riesgos de mercado, tecnológicos y regulatorios.',
        ],
      },
      {
        text: 'Flowex Pay NO es una entidad financiera vigilada por la Superintendencia Financiera de Colombia, NO es un banco, NO capta recursos del público y NO ofrece productos del mercado de valores. Los servicios ofrecidos NO están protegidos por el seguro de depósito del Fogafin ni por ningún mecanismo público o privado equivalente. Los activos digitales y las recompensas generadas a través de protocolos DeFi NO son moneda de curso legal en Colombia.',
      },
    ],
  },
  {
    question: '¿QUIÉN PUEDE USAR FLOWEX PAY?', // 2
    answers: [
      {
        type: 'circle',
        text: 'Para registrarte y usar nuestros servicios debes cumplir con los siguientes requisitos:',
        subText: [
          'Ser persona natural mayor de 18 años residente en Colombia, o ser una persona jurídica legalmente constituida y con domicilio principal en Colombia.',
          'Proporcionar información veraz, completa y actualizada, la cual será verificada por nuestro aliado Bridge (o por el proveedor que Flowex Pay designe) mediante procesos de Conocimiento del Cliente (KYC), cumplimiento SAGRILAFT y reporte a la UIAF.',
          'No encontrarse incluido en listas vinculantes nacionales o internacionales de sanciones (OFAC, ONU, UE, entre otras), ni en listas restrictivas de lavado de activos o financiación del terrorismo.',
          'Aceptar expresamente estos Términos y Condiciones y la Política de Privacidad al momento del registro.',
        ],
      },
      {
        text: 'Los corredores internacionales (por ejemplo Brasil vía PIX o México vía SPEI) están disponibles para que usuarios residentes en Colombia envíen fondos a beneficiarios ubicados en esos países; no están destinados a residentes o ciudadanos de esos países como usuarios finales de la plataforma. Nos reservamos el derecho a rechazar el registro, suspender o terminar cualquier cuenta, en cualquier momento y sin requerir expresión de causa, cuando detectemos incumplimientos, información falsa, operaciones inusuales o riesgos reputacionales, operativos, legales o financieros.',
      },
    ],
  },
  {
    question:
      '¿CÓMO FUNCIONAN LAS TRANSFERENCIAS INTERNACIONALES CON FLOWEX PAY?', // 3
    answers: [
      {
        type: 'abc',
        text: 'Puedes enviar dinero al extranjero siguiendo estos pasos:',
        subText: [
          'Recargas tu saldo en Flowex Pay a través de los medios de pago habilitados (por ejemplo PSE).',
          'Convertimos tus pesos colombianos a la moneda de la transacción según la tasa de cambio vigente al momento de la conversión, que incluye un spread operativo que te será informado antes de confirmar la operación.',
          'Los fondos convertidos se almacenan temporalmente en cuentas segregadas a nombre de Loaded Colombia SAS (o de nuestros aliados operativos) y transitan a través de los rieles de pago correspondientes según el país de destino: ACH (Estados Unidos), SEPA (Europa), SPEI (México), PIX (Brasil), y otros corredores habilitados.',
          'Para Brasil utilizamos el sistema PIX: deberás ingresar la llave PIX del beneficiario (CPF, CNPJ, correo, teléfono o llave aleatoria) y el tipo de llave correspondiente. También se generan QR dinámicos (Copia e Cola) cuando aplica.',
          'Por razones de seguridad, enviamos un código de autorización de un solo uso (OTP) que deberás ingresar para aprobar cada transferencia. Ninguna transferencia se ejecuta sin dicha autorización.',
          'Los tiempos de llegada, los cobros por parte de bancos intermediarios, los rechazos por parte del banco receptor y los costos aplicables al beneficiario en destino no dependen de Flowex Pay y pueden variar.',
        ],
      },
    ],
  },
  {
    question: '¿QUÉ ES LA CUENTA VIRTUAL EN ESTADOS UNIDOS Y CÓMO FUNCIONA?', // 4
    answers: [
      {
        type: 'circle',
        text: 'Te proporcionamos, a través de nuestro aliado Bridge, una cuenta virtual en Estados Unidos con número de cuenta y routing number que te permite:',
        subText: [
          'Enviar y recibir pagos en dólares estadounidenses desde y hacia cuentas bancarias de Estados Unidos, lo cual resulta útil para recibir pagos de clientes, pagar proveedores, brokers o servicios internacionales.',
          'Los fondos recibidos en esta cuenta virtual se acreditan en tu saldo en Flowex Pay y tú decides cómo disponer de ellos (convertir a pesos, enviar a otro país, o destinar al producto Rewards descrito en la sección 5).',
        ],
      },
      {
        text: 'Esta cuenta NO es una cuenta bancaria propia del usuario en los Estados Unidos, sino un servicio virtual (virtual account / for-benefit-of) ofrecido por Bridge y sus instituciones bancarias aliadas. Los fondos no están asegurados por el FDIC en cabeza del usuario final y no están sujetos a las protecciones de las regulaciones bancarias colombianas ni estadounidenses aplicables a cuentas de depósito a nombre del cliente. La disponibilidad de la cuenta puede estar condicionada a verificación de identidad, políticas de riesgo y límites operativos de Bridge.',
      },
    ],
  },
  {
    question:
      'PRODUCTO REWARDS ON-CHAIN: KAMINO, USDC Y SOLANA', // 5
    answers: [
      {
        type: 'circle',
        text: 'El producto Rewards on-chain (en adelante, “Rewards”) es un servicio opcional mediante el cual el usuario destina voluntariamente activos digitales estables (USDC) a un protocolo de finanzas descentralizadas (DeFi) para generar recompensas variables. Características del producto:',
        subText: [
          'Protocolo integrado: Kamino Main Market, desplegado en la red Solana (protocolo de lending on-chain operado por Kamino Finance, independiente de Flowex Pay).',
          'Activo soportado: USDC (moneda estable emitida por Circle Internet Financial). Las recompensas se acumulan y se pagan en USDC.',
          'Rol de Flowex Pay: intermediario tecnológico. Flowex Pay NO custodia USDC en billeteras propias del usuario, NO administra el protocolo Kamino y NO fija la tasa de recompensa (APY). La tasa es determinada por las condiciones de oferta y demanda del mercado on-chain y puede cambiar hora a hora.',
          'Comprobante de posición: al destinar fondos a Kamino, el protocolo emite un token de depósito (kToken, por ejemplo kUSDC) que representa la participación del usuario en el pool de oferta del mercado. Dicho token no es transferible al usuario ni constituye un título valor.',
          'Liquidez y retiros: salvo indicación en contrario dentro de la plataforma, los retiros del principal y de las recompensas pueden ejecutarse de forma substancialmente inmediata, sujetos al tiempo de finalización de bloque en Solana, a la disponibilidad de liquidez del mercado en el protocolo (utilization ratio) y a los tiempos operativos de Flowex Pay para procesar y liquidar la operación. En escenarios de alta utilización del mercado, el retiro inmediato podría no estar disponible hasta que haya liquidez suficiente.',
          'Autorización: toda operación de depósito o retiro requerirá autorización explícita del usuario mediante código OTP.',
        ],
      },
      {
        text: 'Flowex Pay NO garantiza rendimientos mínimos, máximos ni constantes. Las recompensas pueden reducirse a cero, volverse negativas por eventos del protocolo (por ejemplo, socialización de pérdidas derivadas de préstamos incobrables, mal funcionamiento de oráculos o exploits) y el principal depositado puede perderse parcial o totalmente como consecuencia de riesgos propios del ecosistema DeFi descritos en la sección 7. Los protocolos DeFi NO están vigilados por la Superintendencia Financiera de Colombia ni por ninguna autoridad financiera colombiana.',
      },
    ],
  },
  {
    question: 'CUSTODIA DE ACTIVOS DIGITALES', // 6
    answers: [
      {
        type: 'circle',
        text: 'Los activos digitales (USDC) que los usuarios destinan al producto Rewards se mantienen y operan desde infraestructura de custodia institucional. Características relevantes:',
        subText: [
          'Utilizamos soluciones de custodia institucional basadas en tecnología MPC (Multi-Party Computation) provistas por Fireblocks, líder global en infraestructura de activos digitales.',
          'Las wallets operativas asociadas al producto no son billeteras personales del usuario; son billeteras operadas por Flowex Pay y sus aliados tecnológicos bajo políticas internas de seguridad, segregación contable, lista blanca de direcciones (whitelisting), reglas de firma y controles transaccionales.',
          'La relación contable del usuario con su saldo on-chain se refleja en su balance dentro de la plataforma Flowex Pay, no en una billetera en su propiedad.',
          'Los riesgos de la custodia tecnológica (incluyendo, sin limitación, compromisos de claves, fallos de proveedores, indisponibilidad temporal del operador de custodia, y eventos extraordinarios del ecosistema) son inherentes al servicio y están cubiertos por las limitaciones de responsabilidad descritas en la sección 17.',
        ],
      },
    ],
  },
  {
    question: 'RIESGOS DEL PRODUCTO REWARDS', // 7
    answers: [
      {
        type: 'circle',
        text: 'Al activar y utilizar el producto Rewards, el usuario reconoce, acepta y asume los siguientes riesgos, de forma enunciativa y no taxativa:',
        subText: [
          'Riesgo de contrato inteligente (smart contract): los contratos de Kamino y sus dependencias pueden contener errores, vulnerabilidades o ser objeto de exploits, con posibles pérdidas totales o parciales del principal y de las recompensas acumuladas.',
          'Riesgo de protocolo: Kamino Finance puede pausar mercados, modificar parámetros (factores de colateralización, topes de depósito, tasas), realizar actualizaciones o migraciones que afecten la posición del usuario.',
          'Riesgo de moneda estable (USDC): USDC es una moneda estable emitida por Circle Internet Financial. Puede perder su paridad con el dólar (de-peg), ser congelada por el emisor en direcciones específicas por sanciones u órdenes de autoridades, o dejar de operar. Ninguno de estos eventos es atribuible a Flowex Pay.',
          'Riesgo de red (Solana): la red Solana puede experimentar congestión, suspensión temporal, bifurcaciones (forks), reorganizaciones de bloque o fallos de validadores que afecten temporal o permanentemente la disponibilidad, integridad o ejecución de transacciones.',
          'Riesgo de oráculos: los precios y estados utilizados por Kamino dependen de oráculos descentralizados; manipulaciones, retrasos o fallos en oráculos pueden generar liquidaciones, valuaciones incorrectas o pérdidas.',
          'Riesgo de liquidez: en momentos de alta utilización del mercado de oferta, el retiro inmediato del principal puede no estar disponible hasta que la liquidez se restablezca.',
          'Riesgo regulatorio: cambios normativos en Colombia, Estados Unidos, la Unión Europea u otras jurisdicciones relevantes pueden obligar a Flowex Pay, a Circle, a Kamino o a terceros a suspender, restringir, reversar o terminar el servicio o sus componentes, total o parcialmente.',
          'Riesgo operativo: fallos en la infraestructura de Flowex Pay, de Fireblocks, de Bridge o de otros aliados pueden ocasionar indisponibilidad temporal del servicio o retrasos en la ejecución o liquidación de operaciones.',
          'Riesgo de mercado y volatilidad: aunque USDC busca mantener paridad con el dólar, y las recompensas se acumulan en USDC, la interacción con otros activos o con tasas variables de protocolos puede implicar volatilidad relevante.',
          'Riesgo cambiario: si el usuario ingresó al producto desde pesos colombianos y desea salir a pesos colombianos, el diferencial entre tasas de cambio de entrada y salida puede generar resultados negativos, independientes del rendimiento en USDC.',
        ],
      },
      {
        text: 'Las recompensas proyectadas o mostradas en la plataforma son estimativas y con fines informativos; NO constituyen oferta de rendimiento, garantía ni promesa de resultado. El usuario declara que entiende cada uno de los riesgos anteriores y que el capital destinado al producto Rewards proviene de fuentes propias y lícitas, cuya eventual pérdida no compromete su estabilidad financiera.',
      },
    ],
  },
  {
    question: '¿QUIÉN CONTROLA MIS FONDOS?', // 8
    answers: [
      {
        text: 'El usuario conserva el control dispositivo de sus fondos: ninguna operación (transferencia internacional, conversión de moneda, depósito en el producto Rewards o retiro del mismo) se ejecuta sin autorización expresa mediante código OTP. Los fondos fiat del usuario se mantienen en cuentas segregadas contables, separadas de los recursos propios de Loaded Colombia SAS. Los activos digitales se mantienen en infraestructura de custodia institucional (ver sección 6). Flowex Pay no utiliza los fondos del usuario para fines propios ni los compromete en operaciones distintas a las autorizadas por el usuario.',
      },
    ],
  },
  {
    question: '¿ES SEGURO USAR FLOWEX PAY?', // 9
    answers: [
      {
        type: 'circle',
        text: 'Aplicamos medidas de seguridad tecnológicas, operativas y normativas para proteger tus datos y operaciones:',
        subText: [
          'Procesos de KYC y verificación de identidad con Bridge u otros proveedores autorizados.',
          'Programas de cumplimiento SAGRILAFT y reporte a la UIAF, conforme a la normativa colombiana aplicable a actividades de alto riesgo en materia de activos virtuales.',
          'Cifrado en tránsito y en reposo de información sensible, controles de acceso y auditoría de eventos críticos.',
          'Custodia institucional con Fireblocks (tecnología MPC, whitelisting de direcciones, políticas de firma y controles transaccionales).',
          'Autenticación multifactor para operaciones sensibles (OTP por SMS o correo según la operación).',
        ],
      },
      {
        text: 'Ningún sistema es completamente inmune a fallos o ataques. Flowex Pay no será responsable por pérdidas derivadas de eventos fuera de nuestro control razonable, incluidos, sin limitación: ciberataques, exploits o fallos de protocolos DeFi, incidentes en proveedores (Bridge, Fireblocks, Circle, Kamino, redes blockchain), cambios regulatorios súbitos o eventos de fuerza mayor.',
      },
    ],
  },
  {
    question: '¿QUÉ PASA SI ALGO SALE MAL CON MIS FONDOS?', // 10
    answers: [
      {
        type: 'circle',
        text: 'Ante cualquier incidente que afecte tus operaciones o saldo, nos comprometemos a:',
        subText: [
          'Investigar el incidente dentro de plazos razonables, según su complejidad.',
          'Coordinar con los aliados operativos (Bridge, Fireblocks, bancos liquidadores, u otros) cuando el incidente dependa de sus servicios.',
          'Mantenerte informado sobre el estado y resolución del caso a través de los canales oficiales.',
        ],
      },
      {
        text: 'Puedes contactarnos en soporte@flowexpay.com o al WhatsApp +57 320 408 8142. Flowex Pay no será responsable por pérdidas derivadas de errores, retrasos o fallos en los servicios de terceros, ni por eventos del ecosistema DeFi descritos en la sección 7, y su responsabilidad máxima se rige por la sección 17.',
      },
    ],
  },
  {
    question: '¿CUÁLES SON LAS TARIFAS DE FLOWEX PAY?', // 11
    answers: [
      {
        type: 'circle',
        text: 'Las tarifas aplicables al servicio son:',
        subText: [
          'Transferencias internacionales: una tarifa que combina comisión fija/porcentual y el spread aplicable a la tasa de cambio. El valor final se informa y requiere aceptación expresa del usuario antes de ejecutar cada operación.',
          'Cuenta virtual en Estados Unidos: sin costo de apertura ni de mantenimiento, salvo que se anuncie lo contrario con el preaviso correspondiente.',
          'Producto Rewards (Kamino): Flowex Pay aplica una comisión de desempeño equivalente al 15% de las recompensas generadas en USDC (performance fee). El usuario recibe neto el 85% restante. La comisión solo se causa si hay recompensas positivas; no cobramos comisión sobre el principal ni cuando no se generan recompensas.',
          'Retiros internos, conversiones y operaciones complementarias pueden tener tarifas que serán informadas antes de ejecutarse.',
        ],
      },
      {
        text: 'Nos reservamos el derecho de modificar las tarifas con preaviso de mínimo quince (15) días, comunicado a través de correo, notificación in-app o publicación en la plataforma. Las operaciones ya autorizadas antes del cambio mantendrán la tarifa vigente al momento de su autorización.',
      },
    ],
  },
  {
    question: 'IMPUESTOS Y OBLIGACIONES TRIBUTARIAS', // 12
    answers: [
      {
        text: 'El usuario es el único responsable de determinar, liquidar, declarar y pagar los impuestos que apliquen sobre: (i) los ingresos, ganancias o rendimientos derivados del producto Rewards, (ii) las diferencias en cambio generadas en transferencias internacionales, y (iii) cualquier otra operación realizada a través de Flowex Pay. Flowex Pay podrá suministrar reportes informativos cuando las autoridades competentes lo exijan y cuando la ley lo permita, pero NO actúa como agente de retención, NO liquida impuestos en nombre del usuario y NO ofrece asesoría tributaria. El usuario se obliga a mantener los soportes de sus operaciones y a cumplir las obligaciones formales y sustantivas derivadas del Estatuto Tributario colombiano y demás normas aplicables.',
      },
    ],
  },
  {
    question: 'NO ASESORÍA FINANCIERA, DE INVERSIÓN NI FISCAL', // 13
    answers: [
      {
        text: 'La información, métricas, tasas, APY históricos o proyectados, gráficos y contenidos presentados en Flowex Pay tienen carácter exclusivamente informativo y no constituyen recomendación, asesoría ni promesa de inversión, ni asesoría jurídica, contable o tributaria. Cada usuario debe evaluar, bajo su propio criterio y, de considerarlo necesario, asesorado por profesionales independientes, la conveniencia de cada operación en función de su situación personal, su tolerancia al riesgo y sus objetivos financieros.',
      },
    ],
  },
  {
    question: '¿QUÉ LEYES CUMPLIMOS?', // 14
    answers: [
      {
        type: 'circle',
        text: 'Loaded Colombia SAS cumple con la normativa colombiana aplicable, incluyendo:',
        subText: [
          'Régimen de prevención de lavado de activos y financiación del terrorismo (SAGRILAFT) y reporte a la UIAF, en su calidad de empresa que desarrolla actividades con activos virtuales en los términos de la regulación vigente.',
          'Ley 1581 de 2012, Decreto 1074 de 2015 y demás normas sobre protección de datos personales.',
          'Ley 1480 de 2011 (Estatuto del Consumidor) en lo que resulte aplicable.',
          'Régimen cambiario colombiano y normas tributarias vigentes, en lo que concierne a la operación de la sociedad.',
        ],
      },
      {
        text: 'Flowex Pay NO realiza captación masiva y habitual de recursos del público, NO ofrece productos del mercado de valores, NO actúa como intermediario del mercado cambiario autorizado y NO es una entidad vigilada por la Superintendencia Financiera de Colombia. En consecuencia, los servicios no cuentan con las protecciones aplicables a productos bancarios, de valores o del sistema financiero regulado.',
      },
    ],
  },
  {
    question: '¿CUÁLES SON TUS DERECHOS?', // 15
    answers: [
      {
        type: 'circle',
        text: 'Como usuario de Flowex Pay tienes derecho a:',
        subText: [
          'Utilizar los servicios activos en tu cuenta conforme a estos Términos, autorizando cada operación.',
          'Solicitar información sobre el estado de tus fondos, operaciones y posiciones on-chain, conforme a los registros disponibles.',
          'Ejercer los derechos de habeas data consagrados en la Ley 1581 de 2012 (acceso, actualización, rectificación, supresión y revocación de la autorización).',
          'Cerrar tu cuenta en cualquier momento, previa cancelación de saldos pendientes. Los fondos disponibles serán devueltos al usuario, descontando comisiones, impuestos aplicables y operaciones en curso. Los saldos en el producto Rewards deberán ser retirados previamente.',
        ],
      },
    ],
  },
  {
    question: '¿CUÁLES SON TUS RESPONSABILIDADES?', // 16
    answers: [
      {
        type: 'circle',
        text: 'El usuario se obliga a:',
        subText: [
          'Proporcionar información veraz, completa y actualizada, y notificar oportunamente cambios relevantes (domicilio, actividad económica, beneficiarios finales, etc.).',
          'Autorizar cada operación mediante el código OTP que le enviemos y proteger las credenciales de acceso a su cuenta (contraseña, dispositivo, correo, número telefónico).',
          'Entender y aceptar los riesgos de cada servicio, en particular los riesgos del producto Rewards descritos en la sección 7.',
          'No usar Flowex Pay para actividades ilícitas, lavado de activos, financiación del terrorismo, fraude, evasión de sanciones internacionales o cualquier uso prohibido por la ley.',
          'No intentar eludir controles geográficos, de identidad o de sanciones mediante el uso de VPN, identidades falsas, personas interpuestas u otros mecanismos equivalentes.',
          'Cumplir con sus obligaciones tributarias propias y con estos Términos y Condiciones.',
        ],
      },
    ],
  },
  {
    question: 'LIMITACIÓN DE RESPONSABILIDAD', // 17
    answers: [
      {
        type: 'circle',
        text: 'En la máxima medida permitida por la ley aplicable:',
        subText: [
          'Flowex Pay responde únicamente por daños directos, previsibles y efectivamente causados por dolo o culpa grave de Flowex Pay en la prestación de sus servicios.',
          'Flowex Pay no responde por daños indirectos, lucro cesante, pérdida de oportunidad, daño moral, daño emergente consecuencial, ni por pérdidas reputacionales.',
          'Flowex Pay no responde por actos u omisiones de terceros, incluidos, sin limitación: Bridge, Fireblocks, Circle, Kamino Finance, validadores o la red Solana, bancos liquidadores, proveedores de PSE, proveedores de mensajería OTP, emisores o receptores de pagos internacionales.',
          'Flowex Pay no responde por pérdidas derivadas de eventos del ecosistema DeFi (smart contract risk, de-peg, pausas de mercado, exploits, forks, congelamientos por emisores de stablecoins, decisiones de OFAC u otras autoridades).',
          'La responsabilidad agregada máxima de Flowex Pay frente a un usuario, por cualquier causa y en un período de doce (12) meses consecutivos, se limita al mayor valor entre: (i) el monto total de comisiones efectivamente cobradas por Flowex Pay a dicho usuario en los últimos doce (12) meses, o (ii) cien (100) dólares de los Estados Unidos de América (USD 100), salvo que la ley imperativa aplicable disponga un mínimo superior.',
        ],
      },
    ],
  },
  {
    question: 'INDEMNIZACIÓN', // 18
    answers: [
      {
        text: 'El usuario se obliga a mantener indemne a Loaded Colombia SAS, a sus sociedades relacionadas, administradores, empleados, accionistas y aliados operativos frente a cualquier reclamo, acción, sanción, multa, costo, honorario o pérdida (incluidos honorarios razonables de abogados) que se origine en: (i) el incumplimiento por parte del usuario de estos Términos, (ii) la inexactitud de la información suministrada por el usuario, (iii) el uso indebido, fraudulento o ilícito de la plataforma por parte del usuario, o (iv) la violación por parte del usuario de cualquier ley, reglamento o derecho de terceros.',
      },
    ],
  },
  {
    question: 'FUERZA MAYOR', // 19
    answers: [
      {
        text: 'Flowex Pay no será responsable por el incumplimiento o retraso en la prestación de sus servicios cuando ello obedezca a eventos de fuerza mayor o caso fortuito, incluidos, de manera enunciativa: desastres naturales, pandemias, guerra, disturbios, ciberataques de alcance sistémico, fallos generalizados de infraestructura de internet, telecomunicaciones o energía, suspensiones o fallos de redes blockchain (incluida Solana), caída de proveedores críticos (Bridge, Fireblocks, Circle, Kamino), actos de autoridades nacionales o extranjeras que restrinjan o prohíban la operación, cambios regulatorios de efectos inmediatos u otros eventos análogos fuera del control razonable de Flowex Pay.',
      },
    ],
  },
  {
    question: 'PROTECCIÓN DE DATOS PERSONALES', // 20
    answers: [
      {
        text: 'Al usar Flowex Pay, el usuario autoriza a Loaded Colombia SAS, en calidad de Responsable del Tratamiento, para recolectar, almacenar, usar, circular y suprimir sus datos personales con las finalidades descritas en nuestra Política de Privacidad y de conformidad con la Ley 1581 de 2012 y normas concordantes. Los datos serán utilizados para prestar los servicios, cumplir obligaciones legales y de prevención de lavado de activos, atender requerimientos de autoridades competentes y mejorar la experiencia del usuario. Los datos podrán ser compartidos con nuestros Encargados del Tratamiento (Bridge, Fireblocks, proveedores de infraestructura, KYC y mensajería), bajo acuerdos de confidencialidad y seguridad. El usuario puede ejercer sus derechos de habeas data escribiendo a soporte@flowexpay.com.',
      },
    ],
  },
  {
    question: 'CAMBIOS EN LOS TÉRMINOS Y CONDICIONES', // 21
    answers: [
      {
        text: 'Flowex Pay podrá actualizar estos Términos y Condiciones en cualquier momento. Los cambios relevantes serán notificados con al menos quince (15) días de anticipación a través del correo electrónico registrado y/o notificación en la plataforma. Si el usuario no está de acuerdo con los cambios, podrá cerrar su cuenta antes de que entren en vigor. El uso continuado de Flowex Pay después de la fecha de entrada en vigor implica aceptación de la nueva versión.',
      },
    ],
  },
  {
    question: 'RESOLUCIÓN DE CONFLICTOS', // 22
    answers: [
      {
        text: 'Estos Términos se rigen por las leyes de la República de Colombia. Las partes buscarán resolver cualquier controversia de manera directa y de buena fe. De no lograrse un acuerdo dentro de los treinta (30) días calendario siguientes a la primera comunicación escrita, la controversia será sometida a los jueces civiles del circuito de Bogotá, D.C., Colombia, salvo normas imperativas que dispongan una jurisdicción distinta (por ejemplo, en materia de consumo).',
      },
    ],
  },
  {
    question: '¿QUÉ PASA SI NO ESTÁS DE ACUERDO CON ESTOS TÉRMINOS?', // 23
    answers: [
      {
        text: 'Si no aceptas estos Términos y Condiciones, no podrás usar los servicios de Flowex Pay. Al registrarte y usar la plataforma, confirmas que has leído, entendido y aceptado estas condiciones, así como la Política de Privacidad y los anexos o políticas específicas de cada producto.',
      },
    ],
  },
  {
    question: '¿CÓMO CONTACTARNOS?', // 24
    answers: [
      {
        type: 'circle',
        text: 'Para preguntas, quejas, ejercicio de derechos de habeas data o asistencia, contáctanos en:',
        subText: [
          'Correo: soporte@flowexpay.com',
          'WhatsApp: +57 320 408 8142',
          'Horario de atención: lunes a viernes, de 9:00 a.m. a 5:00 p.m. (hora de Colombia).',
        ],
      },
      {
        text: 'Estamos aquí para ayudarte.',
      },
    ],
  },
];

export default function TermsOfServices() {
  return (
    <div className="relative">
      <HeaderWithoutMenu />

      <section className="bg-[linear-gradient(to_right,rgba(0,0,0,0)_0%,#E7EFFF_100%)] py-6">
        <p className="px-10 sm:px-18 lg:px-22.5 py-4 sm:py-6 lg:py-8 font-[poppins] text-[#092F7B] text-[24px] sm:text-[32px] lg:text-[40px] font-semibold leading-[1.1] tracking-[-0.6px]">
          Términos y condiciones
        </p>

        <div className="px-8 sm:px-16 lg:px-20 py-2 sm:py-4 lg:py-6 space-y-6">
          <p className="font-[poppins] text-xs sm:text-sm text-[#092F7B] font-normal leading-[1.5] tracking-[-0.6px]">
            ¡Bienvenido(a) a Flowex Pay, una marca de Loaded Colombia SAS! Somos
            una empresa registrada en la Cámara de Comercio de Bogotá, con NIT
            901910428-1, y estamos comprometidos con ofrecerte un servicio
            seguro y confiable para enviar dinero al extranjero, operar una
            cuenta virtual en Estados Unidos y acceder —en calidad de
            intermediario tecnológico— a protocolos de finanzas
            descentralizadas (DeFi). A continuación te explicamos los términos
            y condiciones que rigen el uso de nuestros servicios. Te pedimos
            leerlos con atención, ya que al usar Flowex Pay aceptas estas
            condiciones. Si tienes dudas, contáctanos en soporte@flowexpay.com
            o al WhatsApp +57 320 408 8142.
          </p>

          {TermsOfServicesData.map((item, i) => (
            <div key={i}>
              <p className="font-[poppins] text-xs sm:text-sm text-[#092F7B] font-medium leading-[1.5] tracking-[-0.6px]">
                {`${i + 1}. ${item.question}`}
              </p>

              {item.answers.map((data, j) => (
                <div
                  key={j}
                  className="font-[poppins] text-xs sm:text-sm text-[#092F7B] font-normal leading-[1.5] tracking-[-0.6px]"
                >
                  <p>{data.text}</p>

                  {data.subText && data.subText.length && (
                    <ul className="list-disc list-inside m-0 pl-4">
                      {data.subText.map((text, k) => (
                        <li key={k}>{text}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          ))}

          <p className="font-[poppins] text-[10px] sm:text-xs text-[#092F7B] font-light leading-[1.5] tracking-[-0.6px] pt-4 italic">
            Última actualización: 19 de abril de 2026. Versión 2.0 — incluye
            actualización de corredor Brasil (PIX), producto Rewards on-chain
            (Kamino / USDC / Solana), custodia institucional con Fireblocks,
            régimen tributario del usuario, limitación de responsabilidad,
            indemnización y fuerza mayor.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
